import { FileIcon, fileKind } from "@corecrm/ui";
import { fileUrl } from "../api/client";
import type { Deliverable } from "../api/types";
import { fileSize } from "../lib/labels";

type File = Deliverable["files"][number];

/** Where a deliverable file opens: the browser shows PDFs, images, HTML and Markdown in a new
    tab; archives and anything else download. */
export function fileLink(deliverableId: string, f: File, download = false) {
  const kind = fileKind(f.filename);
  const path = `/deliverables/${deliverableId}/files/${f.id}`;
  return download || kind === "archive" || kind === "other"
    ? { href: fileUrl(path, true), download: f.filename }
    : { href: fileUrl(path), target: "_blank", rel: "noopener" };
}

/** A deliverable's files, compact, under its name on the project page. */
export function DeliverableFiles({ deliverable: d }: { deliverable: Deliverable }) {
  if (!d.files.length) return null;
  return (
    <ul className="d-files" aria-label={`${d.title} files`}>
      {d.files.map((f) => (
        <li className="file-name" key={f.id}>
          <FileIcon filename={f.filename} />
          <a {...fileLink(d.id, f)}>{f.filename}</a>
          <span className="size">{fileSize(f.size)}</span>
        </li>
      ))}
    </ul>
  );
}
